"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
const immer_1 = __importDefault(require("immer"));
const typesafe_actions_1 = require("typesafe-actions");
const actionCreators = __importStar(require("./actions"));
const initialState = {
    category: null,
    categoryGroup: null,
    series: null,
    seriesType: null,
};
// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => (0, immer_1.default)(state, (draft) => {
    var _a;
    switch (action.type) {
        case (0, typesafe_actions_1.getType)(actionCreators.setCatalogCategory): {
            draft.category = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setCatalogCategoryGroup): {
            draft.categoryGroup = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setCatalogSeries): {
            draft.series = action.payload;
            draft.categoryGroup = null;
            draft.category = null;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setCatalogSeriesType): {
            draft.seriesType = action.payload;
            // eslint-disable-next-line prefer-destructuring
            if (((_a = action.payload) === null || _a === void 0 ? void 0 : _a.series) && action.payload.series.length) {
                draft.series = action.payload.series[0];
            }
            else {
                draft.series = null;
            }
            draft.categoryGroup = null;
            draft.category = null;
            // eslint-disable-next-line no-useless-return
            return;
        }
        default: {
            // eslint-disable-next-line no-useless-return
            return;
        }
    }
});
exports.default = reducer;
